import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils.js";
// The icon spans two rows so it centres on a title and its description; with a title alone the second row is empty.
const alertVariants = cva("relative w-full rounded-xl border px-3.5 py-3 text-sm grid grid-cols-[0_1fr] has-[>svg]:grid-cols-[calc(var(--spacing)*4.5_+_var(--spacing)*3)_1fr] items-center [&>svg]:row-span-2 [&>svg]:size-4.5 [&>svg]:text-current", {
    variants: {
        variant: {
            default: "bg-card text-card-foreground [&_*[data-slot=alert-description]]:text-muted-foreground",
            warning: "bg-alert-warning border-alert-warning-border text-alert-warning-foreground",
            danger: "bg-alert-danger border-alert-danger-border text-alert-danger-foreground",
            info: "bg-alert-info border-alert-info-border text-alert-info-foreground",
            success: "bg-success border-success-border text-success-foreground [&_*[data-slot=alert-description]]:text-success-foreground/70",
        },
    },
    defaultVariants: {
        variant: "default",
    },
});
function Alert({ className, variant, action, children, ...props }) {
    return (_jsxs("div", { "data-slot": "alert", role: "alert", className: cn(alertVariants({ variant }), action && "@container", className), ...props, children: [children, action && (_jsx("div", { "data-slot": "alert-action", className: "col-start-2 row-start-3 mt-2 flex flex-wrap items-center gap-2 @md:col-start-3 @md:row-span-2 @md:row-start-1 @md:mt-0 @md:ms-3", children: action }))] }));
}
function AlertTitle({ className, ...props }) {
    return (_jsx("h4", { "data-slot": "alert-title", className: cn("col-start-2 min-h-4 font-bold tracking-tight", className), ...props }));
}
function AlertDescription({ className, ...props }) {
    return (_jsx("div", { "data-slot": "alert-description", className: cn("col-start-2 grid justify-items-start gap-1 text-sm [&_p]:leading-relaxed [[data-slot=alert-title]+&]:mt-0.5", className), ...props }));
}
export { Alert, AlertTitle, AlertDescription };
//# sourceMappingURL=Alert.js.map